// src/pages/Payments.js
import React from 'react';
import PaymentsContainer from '../components/payments';

const Payments = () => {
  return <PaymentsContainer />;
};

export default Payments;